import _extends from "babel-runtime/helpers/extends";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _ from "lodash";
import Vue from "vue";
import message from "./src/message";
var Message = Vue.extend(message);

var instance = new Message();
instance.vm = instance.$mount();
document.body.appendChild(instance.vm.$el);

function init(options) {

  var defaultOptions = {
    showMsgBox: true,
    confirmedAction: function confirmedAction() {
      consoleLog("可选的确认按钮点击事件");
    },
    canceledAction: function canceledAction() {
      consoleLog("可选的取消按钮点击事件");
    },
    hasMask: true,
    noPlayVoice: false,
    voiceFullyMatch: false };

  if (_.isString(options)) {
    defaultOptions.messageText = options;
  }

  var currentLoadingNode = document.getElementById("loadingNode");
  if (currentLoadingNode) {
    document.body.removeChild(currentLoadingNode);
  }
  return _Object$assign(defaultOptions, options);
}

window.alert = Vue.prototype.alert = function (options) {
  var obj = {
    ownClass: "",
    msg_icon: "alert",
    cancelButtonText: "",
    confirm_icon: "",
    cancel_icon: "",
    confirmButtonText: "确定",
    messageTitle: "提示",
    clickModalAction: function clickModalAction() {
      consoleLog("可选的遮罩层点击事件");
    },
    canceledAction: function canceledAction() {
      consoleLog("可选的取消按钮点击事件");
    }
  };
  _Object$assign(instance, obj, init(options), {
    "typeMessage": "alert"
  });
};

Vue.prototype.confirm = function (options) {
  var obj = {
    ownClass: "",
    msg_icon: "reset",
    confirm_icon: "edit",
    cancel_icon: "smile",
    cancelButtonText: "取消",
    confirmButtonText: "确定",
    canceledAction: function canceledAction() {
      consoleLog("可选的取消按钮点击事件");
    }
  };
  _Object$assign(instance, obj, init(options), {
    "typeMessage": "confirm"
  });
};

Vue.prototype.error = function (options) {
  var obj = {
    ownClass: "",
    confirm_icon: "go",
    cancel_icon: "cancel",
    cancelButtonText: "取消",
    error_title: "你的资料存在部分问题",
    error_info: "请您根据下方提示进行修改",
    confirmButtonText: "确定",
    canceledAction: function canceledAction() {
      consoleLog("可选的取消按钮点击事件");
    }
  };
  _Object$assign(instance, obj, init(options), {
    "typeMessage": "error"
  });
};

Vue.prototype.userMsg = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "service",
    cancel_icon: "home",
    cancelButtonText: "返回首页",
    confirmButtonText: "",
    userMsg: {
      user_img: "",
      enter_name: "",
      return_name: "",
      enter_code: "",
      return_code: ""
    },
    canceledAction: function canceledAction() {
      consoleLog("可选的取消按钮点击事件");
    }
  };
  _Object$assign(instance, obj, init(options), {
    "typeMessage": "userMsg"
  });
};

Vue.prototype.eval = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "reload",
    cancel_icon: "home",
    cancelButtonText: "返回首页",
    confirmButtonText: "重新测评"
  };
  var evaluate = {
    messageTitle: opt.messageTitle,
    lv: opt.lv,
    info: opt.info,
    point: opt.point
  };
  _Object$assign(instance, obj, init(opt), {
    "typeMessage": "eval",
    "evaluate": evaluate
  });
};

Vue.prototype.custEval = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "reload",
    cancel_icon: "home",
    cancelButtonText: "返回首页",
    confirmButtonText: "重新测评"
  };
  var custEvaluate = {
    title: opt.title,
    lv: opt.lv,
    score: opt.score,
    lvDate: opt.lvDate,
    lvExpDate: opt.lvExpDate,
    remainingEval: opt.remainingEval
  };
  _Object$assign(instance, obj, init(opt), {
    "typeMessage": "custEval",
    custEvaluate: custEvaluate
  });
};

Vue.prototype.relationshipMsg = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "",
    cancel_icon: "",
    cancelButtonText: "",
    confirmButtonText: "确定"
  };
  var relationshipMsg = {
    title: opt.title,
    szTips: opt.szTips,
    shTips: opt.shTips
  };
  _Object$assign(instance, obj, init(opt), {
    "typeMessage": "relationshipMsg",
    relationshipMsg: relationshipMsg
  });
};

Vue.prototype.password = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "smile",
    cancel_icon: "cancel",
    cancelButtonText: "取消",
    confirmButtonText: ""
  };
  var password = {
    title: opt.title || "校验资金密码",
    scope: opt.scope || "1",
    CUST_CODE: opt.CUST_CODE || "",
    info: _.isUndefined(opt.info) ? "请确保银行密码正确，否则会导致签约失败！" : opt.info,
    pwd: opt.pwd || "",
    isSecondCheck: opt.isSecondCheck || false
  };
  _Object$assign(instance, obj, init(opt), {
    "typeMessage": "password",
    password: password
  });
};

Vue.prototype.threeElement = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "",
    cancel_icon: "",
    cancelButtonText: "",
    confirmButtonText: "确定"
  };
  var threeElement = {
    title: opt.title || "请再次核对证件信息",
    custInfo: opt.custInfo
  };
  _Object$assign(instance, obj, init(opt), {
    "typeMessage": "threeElement",
    threeElement: threeElement
  });
};

Vue.prototype.exsTip = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "",
    cancel_icon: "",
    cancelButtonText: "",
    confirmButtonText: "关闭"
  };
  var exsTip = {
    title: opt.title,
    dialogFormVisible: opt.dialogFormVisible
  };

  var cleanOpt = _extends({}, opt);
  if (cleanOpt.title) {
    cleanOpt.messageTitle = cleanOpt.title;
    delete cleanOpt.title;
  }
  _Object$assign(instance, obj, init(cleanOpt), {
    "typeMessage": "exsTip",
    exsTip: exsTip
  });
};

Vue.prototype.promote = function (options) {
  var instance = init(options);
  var ownDefaultOptions = {
    ownClass: "",
    "hasInput": true,
    "confirmButtonText": _.isObject(options) && options.confirmButtonText || "确认",
    "cancelButtonText": _.isObject(options) && options.cancelButtonText || "取消",
    "validType": "email",
    "confirmedAction": _.isObject(options) && _.isFunction(options.confirmedAction) ? options.confirmedAction : function () {
      consoleLog("可选的确认按钮点击事件");
    },
    "canceledAction": _.isObject(options) && _.isFunction(options.canceledAction) ? options.canceledAction : function () {
      consoleLog("可选的取消按钮点击事件");
    }
  };
  instance.messageOptions = _.assign(options, ownDefaultOptions);
};

Vue.prototype.readCardMsg = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "go",
    cancel_icon: "home",
    cancelButtonText: "返回首页",
    confirmButtonText: "确认",
    readCardMsg: {
      title: "系统信息校验结果",
      custName: "",
      custIdCode: "",
      cardName: "",
      cardIdCode: ""
    },
    canceledAction: function canceledAction() {
      consoleLog("可选的取消按钮点击事件");
    }
  };
  _Object$assign(instance, obj, init(options), {
    "typeMessage": "readCardMsg"
  });
};

Vue.prototype.openCheckCode = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "go",
    cancel_icon: "cancel",
    cancelButtonText: "返回",
    confirmButtonText: "确认",
    checkCode: {
      title: options.title || "请输入验证码",
      imgSrc: options.imgSrc || ""
    },
    canceledAction: function canceledAction() {},
    additonalAction: function additonalAction() {}
  };
  _Object$assign(instance, obj, init(options), {
    "typeMessage": "checkCode"
  });
};

Vue.prototype.alert.use = function () {
  var example = {
    messageText: "提示框内容",
    cancelButtonText: "取消按钮文本",
    confirmButtonText: "确定按钮文本",
    showMsgBox: "用来关闭弹框",

    error_title: "错误提示框title",
    error_info: "错误提示框提示文字",
    msg_icon: "reset, submit, edit, cancel || alert, question, warn",
    confirm_icon: "reload, upload, edit, smile,go，service",
    cancel_icon: "smile, cancel,account,home,check",
    userMsg: {
      user_img: "",
      enter_name: "",
      return_name: "",
      enter_code: "",
      return_code: ""
    }
  };
  consoleLog(example);
};
Vue.prototype.showTips = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "smile",
    cancelButtonText: "",
    confirmButtonText: "我知道了",
    showTips: {
      title: opt.title || "提示信息",
      tips: opt.tips || []
    }
  };
  _Object$assign(instance, obj, init(opt), {
    "typeMessage": "showTips"
  });
};
Vue.prototype.cry = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    confirm_icon: "smile",
    cancel_icon: "el-icon-back",
    cancelButtonText: "我去意已决",
    confirmButtonText: "再给个机会"
  };
  var cry = {
    name: options.name,
    day: options.day
  };
  _Object$assign(instance, obj, init(options), {
    "typeMessage": "cry",
    cry: cry
  });
};
Vue.prototype.macAddress = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var obj = {
    ownClass: "",
    confirm_icon: "go",
    cancel_icon: "cancel",
    cancelButtonText: "取消保存",
    confirmButtonText: "保存修改"
  };
  var macAddress = {};
  _Object$assign(instance, obj, init(opt), {
    "typeMessage": "macAddress",
    macAddress: macAddress
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/message/index.js
// module id = 1511
// module chunks = 2